export enum DialogType {
    Warning = 'warning',
    Delete = 'delete',
    Info = 'info',
    Error = 'error',
    Input = 'input',
    Confirm = 'confirm'
}
